import { useCallback } from 'react';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { setCredentials, logout as logoutAction, selectCurrentUser, selectIsAuthenticated, selectAuthLoading, } from '@features/auth/authSlice';
import { useLoginMutation, useRegisterMutation, useLogoutMutation, } from '@services/authApi';
export function useAuth() {
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectCurrentUser);
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const isLoading = useAppSelector(selectAuthLoading);
    const [loginMutation, { isLoading: isLoginLoading }] = useLoginMutation();
    const [registerMutation, { isLoading: isRegisterLoading }] = useRegisterMutation();
    const [logoutMutation] = useLogoutMutation();
    const login = useCallback(async (credentials) => {
        try {
            const result = await loginMutation(credentials).unwrap();
            dispatch(setCredentials(result));
            return { success: true, user: result.user };
        }
        catch (error) {
            return {
                success: false,
                error: error.data?.message || '登录失败，请重试',
            };
        }
    }, [loginMutation, dispatch]);
    const register = useCallback(async (userData) => {
        try {
            const result = await registerMutation(userData).unwrap();
            dispatch(setCredentials(result));
            return { success: true, user: result.user };
        }
        catch (error) {
            return {
                success: false,
                error: error.data?.message || '注册失败，请重试',
            };
        }
    }, [registerMutation, dispatch]);
    const logout = useCallback(async () => {
        try {
            await logoutMutation().unwrap();
        }
        catch (error) {
            // 即使API调用失败，也要清除本地状态
            console.error('Logout API failed:', error);
        }
        finally {
            dispatch(logoutAction());
        }
    }, [logoutMutation, dispatch]);
    return {
        user,
        isAuthenticated,
        isLoading: isLoading || isLoginLoading || isRegisterLoading,
        login,
        register,
        logout,
    };
}
